import fetch from 'isomorphic-fetch'; //请求库
import gps from './gps';

/**
 * 封装的接口请求方法
 * @param {*} url 请求地址
 * @param {*} data 请求参数
 * @param {*} type 请求类型
 * @param {*} token token验证
 */
const myfetch = (url, data = {}, type = 'GET', token = '') => {
  //公用的参数
  let parmas = {
    body: JSON.stringify(data),
    headers: {
      'content-type': 'application/json',
      // Authorization: 'Token ' + token,
    },
    method: type,
  };
  //fettch get/head 请求不能包含body
  if (type == 'GET' || type == 'HEAD') {
    delete parmas.body;
  }
  //利用promise去使用fetch请求
  return Promise.race([fetch(url, parmas)])
    .then(response => detailResp(response))
    .catch(() => { });
};

//post请求调用的方法
const postData = (url, data) => {
  return myfetch(url, data, 'POST', localStorage.token);
};
//get请求的调用方法
const getData = (url, token) => {
  return myfetch(url, '', 'GET', localStorage.token);
};

const detailResp = response => {
  if (response.status >= 400 && response.status < 500) {
    // Toast.info("请求失败", 1);
    //    mytoast("请求失败:" + response.status, 1);
    return;
  } else if (response.status >= 500) {
    // Toast.info("服务器异常", 1);
    //    mytoast("服务端异常:" + response.status, 1);
    return;
  }
  return response.json();
};

//从地址获取参数对象
const getArgs = url => {
  let args = new Object();
  let query = null;
  if (!url) {
    query = window.location.search.substring(1);
  } else {
    query = url.split('?')[1];
  }
  let pairs = query.split('&');
  for (let i = 0; i < pairs.length; i++) {
    let pos = pairs[i].indexOf('=');
    if (pos == -1) continue;
    let argname = pairs[i].substring(0, pos);
    let value = pairs[i].substring(pos + 1); // 取参数值
    value = decodeURIComponent(value); // 若需要，则解码
    args[argname] = value; // 存成对象的一个属性
  }
  return args; // 返回此对象
};

const promisify = api => {
  return (options, ...params) => {
    return new Promise((resolve, reject) => {
      const extras = {
        success: resolve,
        fail: reject,
      };
      api(
        {
          ...options,
          ...extras,
        },
        ...params
      );
    });
  };
};
const gpsDistance = (area, gps) => {
  const lat1 = (Math.PI / 180) * area[1];
  const lat2 = (Math.PI / 180) * gps[1];
  const lon1 = (Math.PI / 180) * area[0];
  const lon2 = (Math.PI / 180) * gps[0];
  // 地球半径
  const R = 6371;
  // 两点间距离 km
  const d = Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)) * R;
  return d * 1000;
};
/**
 * 获取最近景点信息
 *
 */
const getNearestJDPoint = (pos, poiInfo, scenicId, level = 1) => {
  if (pos.length === 0) {
    pos = [0, 0];
  }
  let scenicArr = [];
  let disArr = [];
  let disIdArr = [];
  poiInfo.map((item, index) => {
    item.isNearest = false;
    if (scenicId == item.area.id) {
      scenicArr.push(item);
      if (item.level == level) {
        disArr.push(gpsDistance(pos, item.gps));
        disIdArr.push(item.id);
      }
    }
  });
  if (disArr.length === 0) {
    disArr.push(gpsDistance(pos, scenicArr[0].gps));
    disIdArr.push(scenicArr[0].id);
  }
  const index = indexOfSmallest(disArr);
  let resArr = [];
  poiInfo.map(item => {
    if (item.id == disIdArr[index]) {
      item.isNearest = true;
    }
    resArr.push(item);
  });
  // levelTopArr[index].isNearest = true;
  return resArr;
};
/**
 * 获取最近景点信息
 *
 */
// const getNearestJDPoint = (pos, poiInfo,scenicId, level = 1) => {
//     if (pos.length == 0) {
//         pos = [0, 0];
//     }
//     let levelTopArr = [];
//     let levelLowArr = [];
//     let disArr = [];
//     poiInfo.map((item, index) => {
//         item.isNearest = false;
//         item.level == level ? levelTopArr.push(item) : levelLowArr.push(item)
//         if (item.level == level) {
//             disArr.push(gpsDistance(pos, item.gps));
//         }
//     })
//     const index = indexOfSmallest(disArr);
//     levelTopArr[index].isNearest = true;
//     return levelTopArr.concat(levelLowArr);
// }
/**
 * 获取最近点信息
 */
const getNearestPoint = (pos, poiInfo) => {
  let disArr = [];
  if (poiInfo.length > 0) {
    if (pos == [0, 0]) {
      poiInfo[2].isNearest = true;
      // return poiInfo;
    } else {
      poiInfo.forEach(item => {
        item.isNearest = false;
        disArr.push(gpsDistance(pos, item.gps));
      });
      const index = indexOfSmallest(disArr);
      poiInfo[index].isNearest = true;
    }
  }
  return poiInfo;
};
// 获取数组中最小值索引
const indexOfSmallest = arr => {
  return arr.indexOf(Math.min.apply(Math, arr));
};

const getPointPos = (bounds, gps, width) => {
  let disPx = (bounds[1][0] - bounds[0][0]) / width;
  let leftTopPos = [bounds[0][0], bounds[1][1]];
  let disX = (gps[0] - leftTopPos[0]) / disPx;
  let disY = -(gps[1] - leftTopPos[1]) / disPx;
  return [disX, disY];
};

// 对微信验证并配置可用的api
const wx_config = () => { };

// const gpsDistance = (area, gps) => {
//     const lat1 = (Math.PI / 180) * area[1];
//     const lat2 = (Math.PI / 180) * gps[1];
//     const lon1 = (Math.PI / 180) * area[0];
//     const lon2 = (Math.PI / 180) * gps[0];
//     // 地球半径
//     const R = 6371;
//     // 两点间距离 km
//     const d = Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) *
//         Math.cos(lat2) * Math.cos(lon2 - lon1)) *
//         R;
//     return d * 1000;
// }

// const backPos = (top, area) => {
//     const areaY = [area[0], top[1]];
//     const areaX = [top[0], area[1]];
//     const distanceY = gpsDistance(area, areaY);
//     const distanceX = gpsDistance(area, areaX);
//     return [distanceX, distanceY];
// }

// gps 转 百度坐标系
const gpsToBaidu = spotList => {
  spotList.map(item => {
    const change = gps.GPSToBaidu(item.gps[1], item.gps[0]);
    item.gps = [change.lng, change.lat];
  });
  return spotList;
};

const getDistance = (userpos, pgps) => {
  return gps.distance(userpos[1], userpos[0], pgps[1], pgps[0]);
};

const gcjToBaidu = (userpos) => {
  const change = gps.chinaToBaidu(userpos[1], userpos[0]);
  return [change.lng, change.lat];
}

const dateFtt = (fmt, date) => {
  var o = {
    "M+": date.getMonth() + 1,                 //月份   
    "d+": date.getDate(),                    //日   
    "h+": date.getHours(),                   //小时   
    "m+": date.getMinutes(),                 //分   
    "s+": date.getSeconds(),                 //秒   
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
    "S": date.getMilliseconds()             //毫秒   
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

const formatSeconds = (a) => {
  var hh = parseInt(a / 3600);
  if (hh < 10) hh = "0" + hh;
  var mm = parseInt((a - hh * 3600) / 60);
  if (mm < 10) mm = "0" + mm;
  var ss = parseInt((a - hh * 3600) % 60);
  if (ss < 10) ss = "0" + ss;
  var length = parseInt(a / 3600) > 0 ? (hh + ":" + mm + ":" + ss) : (mm + ":" + ss);
  if (a > 0) {
    return length;
  } else {
    return "00:00";
  }
}

export {
  postData,
  getData,
  getArgs,
  promisify,
  getNearestJDPoint,
  gpsDistance,
  getPointPos,
  getNearestPoint,
  wx_config,
  gpsToBaidu,
  getDistance,
  gcjToBaidu,
  dateFtt,
  formatSeconds
};
